import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { memo, useCallback, useEffect, } from 'react';
import { AttachmentList } from 'console/tabs/maintenance/history/dialog/attachments/list';
import { maintenance_attachment_reset_upload_action, maintenance_attachment_set_message_action, upload_maintenance_attachment_action, } from 'console/tabs/maintenance/Actions_Reducers/HistoryMaintenanceActions';
import { useAPI } from 'console/shared/api/api-context';
import { Alert, AlertTitle } from '@mui/material';
import { useAction, useAppSelector } from 'console/shared/hooks/redux/hooks';
export const MaintenanceAttachments = memo(function MaintenanceAttachments(props) {
    const { device_id, maintenance, onChangeMaintenance } = props;
    const api = useAPI();
    const { upload, error } = useAppSelector((state) => state.maintenance_attachment);
    const uploadFiles = useAction(upload_maintenance_attachment_action);
    const resetUploadFiles = useAction(maintenance_attachment_reset_upload_action);
    const set_error = useAction(maintenance_attachment_set_message_action);
    const onAddAttachmentToMaintenance = useCallback((ids, filenames) => {
        if (ids == null || filenames == null) {
            return;
        }
        const new_attachment = ids.map((id, i) => ({
            id,
            filename: filenames[i] ?? '',
        }));
        onChangeMaintenance((_maintenance) => ({
            ..._maintenance,
            attachments: _maintenance.attachments != null
                ? [...new Set([..._maintenance.attachments, ...new_attachment])]
                : new_attachment,
        }));
    }, [onChangeMaintenance]);
    useEffect(() => {
        if (upload != null && upload.ids != null && upload.filenames != null) {
            onAddAttachmentToMaintenance(upload.ids, upload.filenames);
            resetUploadFiles();
        }
    }, [upload]);
    const onFileSelect = useCallback((accepted_files) => {
        uploadFiles(accepted_files.map((a_file) => ({ file: a_file, name: a_file.name })));
    }, [uploadFiles]);
    const downloadFile = useCallback(async (attachment_id, action, download_finish) => {
        try {
            if (device_id == null) {
                return;
            }
            const { attachment, filename } = await api.download_maintenance_attachment(device_id, attachment_id);
            action(attachment, filename, api);
        }
        catch (error) {
            const { json } = error;
            set_error({
                title: 'Скачивание файла не удалось',
                message: json?.error_ui ?? 'Ошибка связи с сервером',
            });
        }
        finally {
            download_finish();
        }
    }, [device_id, set_error]);
    const generateUrlForDownloadFileDirectly = useCallback((attachment_id, for_download) => api.get_url('directly_download_maintenance_attachment', {
        attachment_id,
        for_download,
    }, false), []);
    const onDeleteAttachment = useCallback((id) => {
        if (maintenance.attachments != null && id !== '') {
            onChangeMaintenance({
                ...maintenance,
                attachments: maintenance.attachments.filter((item) => item.id !== id),
            });
        }
    }, [maintenance, onChangeMaintenance]);
    return (_jsxs(_Fragment, { children: [error != null && (_jsxs(Alert, { severity: "error", children: [_jsx(AlertTitle, { children: error.title }), error.message] })), _jsx(AttachmentList, { attachments: maintenance.attachments != null ? maintenance.attachments : [], downloadAttachment: downloadFile, deleteAttachment: onDeleteAttachment, loading: upload != null && upload.is_loading, onFileSelect: onFileSelect, onGenerateUrl: generateUrlForDownloadFileDirectly, multiple: true })] }));
});
